import UserSignin from "app/user/sign-in";
import UserSignUp from "./user/sign-up";
import ForgotPwd from "./user/forgot-password";
import ResetPwd from "./user/reset-password";
import TelesalesCustomers from "./telemarketing/customers";
import Organisation from "./teams/organisation";
import Team from "./teams/team";
import Course from "./trainings/course";
import CourseTest from "./trainings/quiz";
import TeamPerformance from "./teams/performance";
import SalesGig from "./gigs/view";
import PromoteView from "./social/promote/view";
import ProductDetailPage from "./transact/product";
import AffiliateLinkPage from "./campaigns/affiliate_link";
import ReferralCodePage from "./user/referral";
import PromoteIndex from "./social/promote";
import FollowCampaignsPage from "./social/follow";
import FollowCampaignViewPage from "./social/follow/view";
import RetweetCampaignViewPage from "./social/retweet/view";
import RetweetCampaignsPage from "./social/retweet";
import CommentCampaignViewPage from "./social/comment/view";
import CommentCampaignsPage from "./social/comment";
import ToolsHomePage from "./tools";
import SellProduct from "./transact/sell";
import DataCollectionPage from "./transact/data_capture";
import DawViewPage from "./activations/daw/view";
import DawOnboardRetailer from "./activations/daw/onboard";
import DawRetailerPage from "./activations/daw/retailer";
import DawRetailersPage from "./activations/daw/retailers";
import DawRetailerViewPage from "./activations/daw/visit";
import DawRetailerVisitPage from "./activations/daw/visit";
import DataCapturePage from "./transact/data_capture_v2";
import SellPage from "./transact/sell_v2";
import PSAViewPage from "./activations/psa";
import PSASampleCustomer from "./activations/psa/sample";
import PSAFeedbackPage from "./activations/psa/feedback";
import LeadBucketPage from "./leads/bucket";
import LeadPage from "./leads/lead";
import SipDialer from "./tools/dialer";
import AfDialer from "./tools/af_dialer";
import CallCenterPage from "./call_center/view";
import TasksPage from "./dashboard/tasks";
import CampaignsIndexPage from "./campaigns";
import CallCenterDialerPage from "./call_center/dialer";
import VisitTrackerLocationsPage from "./visits/locations";
import VisitLocationPage from "./visits/location";
import VisitLocationActivityPage from "./visits/activity";
import VisitLocationOnboardingPage from "./visits/onboard";
import OpsRelationshipsPage from "./ops/relationships";
import OpsEntitiesPage from "./ops/entities";
import OpsEntityPage from "./ops/entity";
import OpsEntityActivityPage from "./ops/activity";
import OpsOnboardingPage from "./ops/onboard";
import OpsSalesPage from "./ops/sell";
import OpsSalesPaymentPage from "./ops/payment_page";
import OpsSalesHistoryPage from "./ops/sales";
import InventoryTrackerPage from "./inventory/tracker";
import OpsSaleOrderPage from "./ops/sale";
import WhatsAppNumberConversationsPage from "./wacc/conversations";
import WaccAgentNumbers from "./wacc";
import WaccAgentNumber from "./wacc/view";
import LaddarOSPage from "./home/os";
import Dashboard from "./dashboard";
import CheckInRequestsPage from "./check_ins";
import VisitTrackersPage from "./visits/trackers";
import WaccNumbersPage from "./wacc";

const appRoutes = [
  {
    name: "Sign In",
    key: "sign-in",
    route: "/sign-in",
    component: <UserSignin />,
    secure: false,
  },
  {
    name: "Sign Up",
    key: "sign-up",
    route: "/sign-up",
    component: <UserSignUp />,
    secure: false,
  },
  {
    name: "Forgot Password",
    key: "forgot-password",
    route: "/forgot-password",
    component: <ForgotPwd />,
    secure: false,
  },
  {
    name: "Reset Password",
    key: "reset-password",
    route: "/reset-password",
    component: <ResetPwd />,
    secure: false,
  },
  {
    type: "collapse",
    name: "Sell",
    key: "sell",
    route: "/sell",
    component: <SellProduct />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Data Capture",
    key: "data-capture",
    route: "/data-capture",
    component: <DataCollectionPage />,
    secure: true,
  },
  {
    name: "Telemarketing Customers",
    key: "telesales-customers",
    route: "/telesales/customers/:id",
    component: <TelesalesCustomers />,
    secure: true,
  },
  {
    name: "Organisation",
    key: "organisation",
    route: "/organisations/:id",
    component: <Organisation />,
    secure: true,
  },
  {
    name: "Team",
    key: "team",
    route: "/organisations/teams/:id",
    component: <Team />,
    secure: true,
  },
  {
    name: "Team Performance",
    key: "team-performance",
    route: "/teams/performance/:id",
    component: <TeamPerformance />,
    secure: true,
  },
  {
    name: "Course",
    key: "training-course",
    route: "/courses/:id",
    component: <Course />,
    secure: true,
  },
  {
    name: "Quiz",
    key: "training-course-quiz",
    route: "/courses/tests/:id",
    component: <CourseTest />,
    secure: true,
  },
  {
    name: "Gig",
    key: "sales-gig",
    route: "/gigs/:ref",
    component: <SalesGig />,
    secure: true,
  },
  {
    name: "Promote",
    key: "promote",
    route: "/promotions/:ref",
    component: <PromoteView />,
    secure: true,
  },
  {
    name: "Promote",
    key: "promote",
    route: "/promotions/:ref/:smmPlatform",
    component: <PromoteView />,
    secure: true,
  },
  {
    name: "Product",
    key: "product",
    route: "/product-hub/:ref",
    component: <ProductDetailPage />,
    secure: true,
  },
  {
    name: "Affiliate Link",
    key: "affiliate-link",
    route: "/affiliate-links/:ref",
    component: <AffiliateLinkPage />,
    secure: true,
  },
  {
    name: "Referral Code",
    key: "referral-code",
    route: "/referral-code",
    component: <ReferralCodePage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Promote",
    key: "promotions",
    route: "/promotions",
    component: <PromoteIndex />,
    secure: true,
  },
  {
    name: "Follow Campaign",
    key: "follow-campaigns",
    route: "/follow-campaigns",
    component: <FollowCampaignsPage />,
    secure: true,
  },
  {
    name: "Follow Campaign",
    key: "follow-campaign",
    route: "/follow-campaigns/:ref",
    component: <FollowCampaignViewPage />,
    secure: true,
  },
  {
    name: "Retweet Campaign",
    key: "retweet-campaigns",
    route: "/retweet-campaigns",
    component: <RetweetCampaignsPage />,
    secure: true,
  },
  {
    name: "Retweet Campaign",
    key: "retweet-campaign",
    route: "/retweet-campaigns/:ref",
    component: <RetweetCampaignViewPage />,
    secure: true,
  },
  {
    name: "Comment Campaign",
    key: "comment-campaigns",
    route: "/comment-campaigns",
    component: <CommentCampaignsPage />,
    secure: true,
  },
  {
    name: "Comment Campaign",
    key: "comment-campaign",
    route: "/comment-campaigns/:ref",
    component: <CommentCampaignViewPage />,
    secure: true,
  },
  {
    name: "Tools",
    key: "tools",
    route: "/tools",
    component: <ToolsHomePage />,
    secure: true,
  },
  {
    name: "DawPage",
    key: "activations/daw",
    route: "/activations/display-win/:ref",
    component: <DawViewPage />,
    secure: true,
  },
  {
    name: "DawPage",
    key: "activations/display-win/retailers/onboard",
    route: "/activations/display-win/retailers/onboard/:ref",
    component: <DawOnboardRetailer />,
    secure: true,
  },
  {
    name: "DawPage",
    key: "activations/display-win/retailers",
    route: "/activations/display-win/:ref/retailers/",
    component: <DawRetailersPage />,
    secure: true,
  },
  {
    name: "DawRetailerPage",
    key: "activations/display-win/retailers/onboard",
    route: "/activations/display-win/retailers/:ref",
    component: <DawRetailerPage />,
    secure: true,
  },
  {
    name: "DawRetailerVisitPage",
    key: "activations/display-win/retailers/onboard",
    route: "/activations/display-win/retailers/visit/:ref",
    component: <DawRetailerVisitPage />,
    secure: true,
  },
  {
    name: "Data Capture V2",
    key: "/campaigns/data-capture/",
    route: "/campaigns/data-capture/:ref",
    component: <DataCapturePage />,
    secure: true,
  },
  {
    name: "Data Capture V2",
    key: "/campaigns/data-capture/",
    route: "/campaigns/data-capture/:ref/:leadRef",
    component: <DataCapturePage />,
    secure: true,
  },
  {
    name: "Sell V2",
    key: "/campaigns/sell/",
    route: "/campaigns/sell/:ref",
    component: <SellPage />,
    secure: true,
  },
  {
    name: "Sell V2",
    key: "/campaigns/sell/",
    route: "/campaigns/sell/:ref/:leadRef",
    component: <SellPage />,
    secure: true,
  },
  {
    name: "PSAPage",
    key: "activations/psa",
    route: "/activations/product-sampling/:ref",
    component: <PSAViewPage />,
    secure: true,
  },
  {
    name: "PSASamplePage",
    key: "activations/psa",
    route: "/activations/product-sampling/record/sample/:ref",
    component: <PSASampleCustomer />,
    secure: true,
  },
  {
    name: "PSAFeedbackPage",
    key: "activations/psa",
    route: "/activations/product-sampling/feedback/:ref",
    component: <PSAFeedbackPage />,
    secure: true,
  },
  {
    name: "Check-In",
    key: "location-check-in",
    route: "/location-check-in",
    component: <CheckInRequestsPage />,
    secure: true,
  },
  {
    name: "LeadBucketPage",
    key: "/lead/buckets/:ref",
    route: "/leads/buckets/:ref",
    component: <LeadBucketPage />,
    secure: true,
  },
  {
    name: "LeadPage",
    key: "/leads/:ref",
    route: "/leads/:ref",
    component: <LeadPage />,
    secure: true,
  },
  {
    name: "CallCenterPage",
    key: "/call-centers/:ref",
    route: "/call-centers/:ref",
    component: <CallCenterPage />,
    secure: true,
  },
  {
    name: "CallCenterPage",
    key: "/call-centers/dialer/:ref",
    route: "/call-centers/dialer/:ref",
    component: <CallCenterDialerPage />,
    secure: true,
  },
  {
    name: "SipDialer",
    key: "/sipdialer",
    route: "/sipdialer",
    component: <AfDialer />,
    secure: true,
  },
  {
    name: "TaskCategories",
    key: "/tasks",
    route: "/tasks",
    component: <TasksPage />,
    secure: true,
  },
  {
    name: "TaskCategories",
    key: "/tasks",
    route: "/tasks/:taskType",
    component: <CampaignsIndexPage />,
    secure: true,
  },
  {
    name: "Visits",
    key: "/visits",
    route: "/visits",
    component: <VisitTrackersPage />,
    secure: true,
  },
  {
    name: "Visits",
    key: "/visits",
    route: "/visits/trackers/:ref",
    component: <VisitTrackerLocationsPage />,
    secure: true,
  },
  {
    name: "Visits",
    key: "/visits/location",
    route: "/visits/locations/:ref",
    component: <VisitLocationPage />,
    secure: true,
  },
  {
    name: "Visits",
    key: "/visits/location",
    route: "/visits/locations/activity/:locationRef/:activityRef",
    component: <VisitLocationActivityPage />,
    secure: true,
  },
  {
    name: "Visits",
    key: "/visits/location/onboard",
    route: "/visits/locations/onboard/:ref",
    component: <VisitLocationOnboardingPage />,
    secure: true,
  },
  {
    route: "/ops/workspaces/:ref",
    component: <OpsRelationshipsPage />,
    secure: true,
  },
  {
    route: "/ops/workspaces/:ref/entities",
    component: <OpsEntitiesPage />,
    secure: true,
  },
  {
    route: "/ops/workspaces/entities/:ref",
    component: <OpsEntityPage />,
    secure: true,
  },
  {
    route: "/ops/workspaces/entities/activity/:entityRef/:activityRef",
    component: <OpsEntityActivityPage />,
    secure: true,
  },
  {
    route: "/ops/workspaces/entities/onboard/:ref",
    component: <OpsOnboardingPage />,
    secure: true,
  },
  {
    route: "/ops/workspaces/entities/sales/:entityRef/:ruleRef",
    component: <OpsSalesPage />,
    secure: true,
  },
  {
    route: "/ops/workspaces/entities/sales/payment/:ref",
    component: <OpsSalesPaymentPage />,
    secure: true,
  },
  {
    route: "/ops/workspaces/entities/sales/history/:ref",
    component: <OpsSalesHistoryPage />,
    secure: true,
  },
  {
    route: "/ops/workspaces/entities/sales/:ref",
    component: <OpsSaleOrderPage />,
    secure: true,
  },
  {
    route: "/inventories/:ref",
    component: <InventoryTrackerPage />,
    secure: true,
  },
  {
    route: "/wacc",
    component: <WaccNumbersPage />,
    secure: true,
  },
  {
    route: "/wacc/numbers/:ref",
    component: <WaccAgentNumber />,
    secure: true,
  },
  {
    route: "/wacc/numbers/:ref/conversations",
    component: <WhatsAppNumberConversationsPage />,
    secure: true,
  },
  {
    route: "/dashboard",
    component: <LaddarOSPage />,
    secure: true,
  },
  {
    route: "/field",
    component: <Dashboard />,
    secure: true,
  },
];

export default appRoutes;
